// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__z82Gv","lds_roller":"style_lds_roller__Svjj1","lds-roller":"style_lds-roller__STnCc"};